import { useEffect } from 'react';
import './LanguageSwitcher.css'
import { useTranslation } from "react-i18next";

export default function LanguageSwitcher({
    languages = [
        { code: 'en', label: 'EN' },
        { code: 'nl', label: 'NL' }
    ],
}) {
    const { i18n } = useTranslation();

    useEffect(() => {
        const stored = typeof window !== 'undefined' ? localStorage.getItem('appLang') : null;
        if (!stored) changeLanguage('en');
    }, []);

    const domainMap = {
        en: 'aivhy.com',
        nl: 'aivhy.nl'
    };

    const maybeRedirectDomain = (lng) => {
        if (typeof window === 'undefined') return false;
        const host = window.location.hostname.toLowerCase();

        // Skip redirect in local/dev environments
        if (host === 'localhost' || host === '127.0.0.1') return false;

        const targetHost = domainMap[lng];
        if (!targetHost) return false;
        if (host === targetHost) return false;

        const newUrl = `${window.location.protocol}//${targetHost}${window.location.pathname}${window.location.search}${window.location.hash}`;
        try { localStorage.setItem('appLang', lng); } catch (e) {}
        window.location.assign(newUrl);
        return true;
    };

    const changeLanguage = (lng) => {
        if (!lng || i18n.language === lng) return;
        // Redirect if domain does not match desired language
        if (maybeRedirectDomain(lng)) return;

        i18n.changeLanguage(lng);
        try { localStorage.setItem('appLang', lng); } catch (e) {}
        try { document.documentElement.lang = lng; } catch (e) {}
    };

    return (
        <div className="lang-switcher" role="navigation" aria-label="Language switcher">
            {languages.map((lng) => (
                <button
                    key={lng.code}
                    type="button"
                    onClick={() => changeLanguage(lng.code)}
                    aria-pressed={i18n.language === lng.code}
                    className={`lang-btn ${i18n.language === lng.code ? 'active' : ''}`}
                    title={lng.label}
                >
                    {lng.label}
                </button>
            ))}
        </div>
    );
}